import { React, useState, useRef, useEffect } from 'react';
import { } from 'react-bootstrap';
import axios from 'axios';

import { Button, Tab, Nav, Form, Modal, Row, Col } from 'react-bootstrap';
import Select from 'react-select'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-enterprise'
function DNDs(props) {

    const [showForm, setShowForm] = useState(false)
    const [isUpdate, setIsupdate] = useState(false)
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({})
    const [custommessage, setMessage] = useState("");
    const [tldInvalid, setTldInvalid] = useState(false);


    const countries = [
        { value: 'in', label: 'India' },
        { value: 'us', label: 'US' }
    ]

    const countryMap = Object.fromEntries(countries.map(c => [c.value, c.label]));

    const columns = [
        { field: 'id', headerName: 'Id', hide: 'true', filter: 'agNumberColumnFilter' },
        { field: 'tld', headerName: 'TLD', hide: 'false', filter: 'agTextColumnFilter' },
        {
            field: 'db',
            headerName: 'Country',
            hide: 'false',
            filter: 'agTextColumnFilter',
            valueFormatter: (params) => countryMap[params.value] || params.value
        }
    ]

    const gridRef = useRef();

    const datasource = {
        getRows: function (params) {
            const serverApiUrl = `/api/dnds/${props.uid}`;
            fetch(serverApiUrl, {
                method: "post",
                headers: { "Content-Type": "application/json; charset=utf-8", "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` }
            })
                .then(httpResponse => httpResponse.json())
                .then(response => {
                    params.successCallback(response.rows, response.lastRow);
                }).catch(error => {
                    console.error(error);
                    params.failCallback();
                });
        }
    }

    useEffect(() => {
        // gridRef.current.api?.setGridOption('serverSideDatasource', datasource);
        gridRef.current.api?.refreshServerSide([]);
    }, [])

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle: { textAlign: 'center' }
    }

    const onGridReady = (params) => {
        gridRef.current.api?.setServerSideDatasource(datasource);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setTldInvalid(false);
        setMessage("");
    }
    
    const handleCountryChange = (selectedOption) => {
        setFormData({ ...formData, country: selectedOption });
    }

    const checkAvailability = async (tld, db) => {
        try {
            const response = await axios.get(`/dnds/check/${tld}/${db}`);
            return response.data ? true : false;
        } catch (error) {
            console.log("API Error", error);
            return false;
        }
    }



    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        const tld = form.elements.tld.value.trim();
        const country = form.elements.country.value;

        const isAvailable = await checkAvailability(tld, country);

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

        }
        else if (isAvailable === false) {
            event.preventDefault();
            event.stopPropagation();

            setTldInvalid(true);
            setMessage("TLD does not exist");
        }
        else if (form.checkValidity() === true) {
            event.preventDefault();
            event.stopPropagation();

            const request = {
                url: '/dnds',
                data: { ...formData, userid: props.uid },
                method: "POST"
            }
            if (request) {
                axios(request).then(() => {
                    alert('Lead is added in DND')
                    gridRef.current.api?.refreshServerSide([]);

                    setFormData({})
                    setValidated(true);
                    setShowForm(false)
                })
                    .catch((err) => {
                        console.log('error occured while adding lead in DND', err)
                        alert('Server Error! unable to add DND')
                    })
            }
        }
        setValidated(true);
    };

    const handleUpdate = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        const tld = form.elements.tld.value.trim();
        const country = form.elements.country.value;

        const isAvailable = await checkAvailability(tld, country);

        if ((form.checkValidity() === false) || (!formData.country)) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if (isAvailable === false) {
            event.preventDefault();
            event.stopPropagation();

            setTldInvalid(true);
            setMessage("TLD does not exist");
        }
        else if ((form.checkValidity() === true)&&(formData.country)) {
            event.preventDefault();
            event.stopPropagation();

            const request = {
                url: '/dnds',
                data: { ...formData, modifiedby: props.uid },
                method: "PUT"
            }

            if (request) {
                axios(request).then(() => {
                    alert('DND is modified')
                    gridRef.current.api?.refreshServerSide([]);
                    setShowForm(false)
                    setFormData({})
                    setIsupdate(false)
                })
                    .catch((err) => {
                        alert('Server Error! unable to update DND')
                    })
            }
        }
        setValidated(true);
    }


    const handleAddNew = () => {
        setValidated(false);
        setShowForm(true);
        setTldInvalid(false);
        setMessage("");
    }

    const handleModify = (node) => {
        axios({
            url: `/dnds/${node.data.id}/${node.data.db}`,
            method: "GET"
        })
            .then((result) => {
                const rowData = result.data[0]
                console.log(rowData);
                const country = countries.find(c => c.value === rowData.country);

                setFormData({ ...rowData, country: country, id: node.data.id });
                setValidated(false)
                setIsupdate(true)
                setShowForm(true)
            })
            .catch((err) => {
                console.log("Error: ", err)
            })
    }

    const handleDelete = (node) => {
        if (window.confirm('Are you sure you want to delete DND')) {
            axios({
                url: `/dnds/${node.data.id}`,
                method: "DELETE"
            })
                .then((result) => {
                    gridRef.current.api?.refreshServerSide([]);
                })
                .catch((err) => {
                    console.log("Error: ", err)
                })
        }
    }

    const getContextMenuItems = (params) => {
        const { node } = params;
        return [
            {
                name: 'New',
                action: () => {
                    handleAddNew()
                },
                icon: <i class="bi bi-plus-lg bi-lg"></i>,
            },
            {
                name: 'Modify',
                action: () => {
                    handleModify(node)
                },
                icon: <i class="bi bi-pencil"></i>,
                disabled: !node && !node?.data
            },
            {
                name: 'Delete',
                action: () => {
                    handleDelete(node)
                },
                icon: <i class="bi bi-trash3"></i>,
                disabled: !node && !node?.data
            },

        ]
    }

    return (<><div className='w-100 h-100 d-flex flex-column overflow-hidden'>
        <Tab.Container defaultActiveKey="dnds">
            <Nav variant='tabs' className='fs-6 border' >
                <Nav.Item><Nav.Link eventKey="dnds">DNDs</Nav.Link></Nav.Item>
                <Nav.Item className='ms-auto'>
                    <Button title="New DNDs" className={`btn btn-primary mx-1 float-right`} onClick={() => { setValidated(false); setShowForm(true); setTldInvalid(false); setMessage(""); }}><i class={`bi bi-plus text-white`} style={{ fontWeight: 'bold' }}></i></Button>
                    <Button title="Refresh" className={`btn btn-primary mx-1 float-right`} onClick={() => gridRef.current.api?.refreshServerSide([])}><i class={`bi bi-arrow-repeat`}></i></Button>
                </Nav.Item>
            </Nav>
            <Tab.Content className='w-100' style={{ height: "calc(100% - 34px)" }} animation={true} mountOnEnter={true} unmountOnExit={true} >
                <Tab.Pane className='w-100 h-100' eventKey="dnds" title="Campaigns">
                    <div className="m-0 p-0 h-100 d-flex flex-row">
                        <div className="border h-100 ag-theme-balham" style={{ width: "100%" }}>
                            <AgGridReact
                                ref={gridRef}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                columnHoverHighlight={'true'}
                                suppressRowGroupHidesColumns={'true'}
                                cacheBlockSize={50}
                                rowModelType={'serverSide'}
                                columnDefs={columns}
                                // serverSideDatasource={datasource}
                                getContextMenuItems={(params) => getContextMenuItems(params)}
                            />
                        </div>
                    </div>
                </Tab.Pane>
            </Tab.Content>
        </Tab.Container>
    </div>

        <Modal show={showForm} size="lg" centered>
            <Modal.Header className='py-2 bg-primary text-white'>
                <div className="fs-5">{isUpdate ? "Update DND" : "Add DND"}</div>
            </Modal.Header>
            <Modal.Body className='p-3 shadow'>
                <div className='d-flex flex-column'>
                    <Form noValidate validated={validated} onSubmit={async (e) => isUpdate ? await handleUpdate(e) : await handleSubmit(e)}>
                        <Row className="mb-3">
                            <Col xs={12} md={4} >
                                <Form.Group >
                                    <Form.Label>TLD{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="TLD"
                                        value={formData.tld}
                                        name="tld"
                                        onChange={handleChange}
                                        isInvalid={(validated && !formData.tld) || tldInvalid}
                                        required
                                    // isValid={!tldInvalid && tldChecked &&formData.tld }
                                    // pattern={'^[a-zA-Z 0-9]+$'}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {tldInvalid ? custommessage : "Please provide a valid TLD."}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={4} >
                                <Form.Group >
                                    <Form.Label>Country{<span style={{ color: 'red' }}>*</span>}</Form.Label>
                                    <div style={{ 'border': (validated && (!formData.country)) ? '1px solid #801030' : undefined, 'border-radius': (validated && (!formData.country)) ? '4px' : undefined }}>
                                    <Select
                                        name='country'
                                        value={formData.country}
                                        isMulti={false}
                                        isClearable={false}
                                        backspaceRemovesValue={true}
                                        closeMenuOnSelect={true}
                                        onChange={handleCountryChange}
                                        options={countries}
                                        isDisabled={false}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                    </div>
                                    {(validated && (!formData.country))&&(
                                        <div className='invalid-feedback d-block'>Please select country</div>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Control
                            type="hidden"
                            value={formData.id}
                            name='id'
                        />
                        <div className='p-2 d-flex justify-content-end'>
                            <Button className='mx-1' variant="secondary" onClick={() => { setShowForm(false); setFormData({}); setIsupdate(false); setValidated(false) }}>
                                Cancel
                            </Button>
                            <Button type='submit' className={`mx-1`} variant="primary">
                                {isUpdate === true ? 'Update' : 'Add'}
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>

    </>)
}
export default DNDs


















